import React, { useReducer, useContext } from "react";
import { coachPoolReducer as reducer } from "../reducers/coachPoolReducer";
import { coachPoolActions as actions } from "../actions/coachPoolActions";

const initialValue = {
  coachPools: null,
  showModal: false,
};

const coachPoolContext = React.createContext();

const CoachPoolContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <coachPoolContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </coachPoolContext.Provider>
  );
};

export const useCoachPoolContext = () => React.useContext(coachPoolContext);
export default CoachPoolContext;
